import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-19072276"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "PriceCalculateRenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观察题干的价值组合来推断不同图案的价值，然后据此判断选项中的哪个选项成立。", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请选择", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_PriceCalculateImage = _resolveComponent("PriceCalculateImage");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }), $props.data.question ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.question.questions, (q, qi) => {
      return _openBlock(), _createElementBlock("div", {
        class: "vpd12 opd24",
        key: `${q.id}_${qi}`
      }, [_createVNode(_component_PriceCalculateImage, {
        data: q
      }, null, 8, ["data"])]);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "mt32 mb32 bothCenter"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), (_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    review: $props.review,
    key: `PriceCalculate_${$props.data.questionIndex}`,
    "option-both-center": false,
    "option-width": "220px",
    reviewMode: $props.reviewMode,
    options: ['A', 'B', 'C', 'D']
  }, {
    default: _withCtx(btnIndex => [_createVNode(_component_PriceCalculateImage, {
      data: $props.data.question[`option${['A', 'B', 'C', 'D'][btnIndex.index]}`]
    }, null, 8, ["data"])]),
    _: 1
  }, 8, ["onChoose", "review", "reviewMode"])), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "flex flex-col bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)]);
}